import { bootstrapApplication } from '@angular/platform-browser';
import { registerLicense } from '@syncfusion/ej2-base';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

/**
 * Syncfusion EJ2 license registration.
 * Replace the empty string below with your Syncfusion license key to
 * suppress the "trial version" banner. Keys can be obtained from
 *   https://www.syncfusion.com/account/downloads
 * For dev, leaving it empty is fine — the banner just shows during preview.
 */
const SYNCFUSION_LICENSE_KEY = environment.SYNCFUSION_LICENSE_KEY;
if (SYNCFUSION_LICENSE_KEY) {
  registerLicense(SYNCFUSION_LICENSE_KEY);
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
